// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewAlertPage_builderRow__OHSEg{display:flex;flex:1 1;min-height:0}.NewAlertPage_canvas__sHeGm{flex:1 1;min-width:0}`, "",{"version":3,"sources":["webpack://./src/apps/admin/pages/NewAlertPage.module.scss"],"names":[],"mappings":"AACA,gCACE,YAAA,CACA,QAAA,CACA,YAAA,CAGF,4BACE,QAAA,CACA,WAAA","sourcesContent":["// See NewCalendarPage.module.scss for the full explanation.\n.builderRow {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n}\n\n.canvas {\n  flex: 1;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"builderRow": `NewAlertPage_builderRow__OHSEg`,
	"canvas": `NewAlertPage_canvas__sHeGm`
};
export default ___CSS_LOADER_EXPORT___;
